import React, { useState, useEffect } from 'react'
import { Development, Property, RealEstateDataPageComponentData } from 'types'
import { makeJsonContact } from '@helpers/helper.contact'
import { useCreateFormMutation as useSendContactFormMutationMediacore } from '@apis/mediacore/contact'
import toast from 'react-hot-toast'
import ReCAPTCHA from 'react-google-recaptcha'
import useQueryDevelopment from '@hooks/useQueryDevelopment'
import { getProducer } from '@helpers/helper.filters'
import useQueryProperty from '@hooks/useQueryProperty'
import $ from 'jquery'

interface ExternalProps {
  developmentID: string
}

interface PropsType {
  property: Property
  development: Development
  from: string
  smallPadding?: boolean
  italic: boolean
  propertyID?: string
  focusSecondary?: boolean
}

type CombinedProps = RealEstateDataPageComponentData & PropsType

const FormDevelopment_3 = (props: CombinedProps) => {
  const [disabled, setDisabled] = useState(true)
  //   const { data } = props
  // const { from = '' } = props
  const {
    property,
    development,
    underlineMode,
    button,
    global_data,
    italic = false,
    smallPadding = false,
    is_short = false,
    focusSecondary = false,
    customBorderRadius,
    propertyID,
    title,
    spanText,
    subtitle,
    paragraphHexa,
    titleHexa,
    height,
  } = props

  const { data, isLoading } = useQueryProperty(propertyID, global_data.pageConfig.keys.tokko)

  const API_KEY = global_data.pageConfig.keys.tokko
  const captcha = global_data.pageConfig.keys.captcha
  const divisionPath = global_data.divisionPath
  const realEstateName = global_data.name
  const [isAbsolute, setIsAbsolute] = useState(false)
  const [sendContactFormMediacore] = useSendContactFormMutationMediacore()
  const [datos, setDatos] = useState({
    name: '',
    cellphone: '',
    email: '',
    text: '',
  })

  const handleInputChange = (event: any) => {
    setDatos({
      ...datos,
      [event.target.name]: event.target.value,
    })
  }

  const sendForm = (event: any) => {
    event.preventDefault()
    var tags = [...getUtm(), 'Sitio Web', realEstateName]
    if (process.env.GATSBY_IS_SITE_COMPILER === 'true') {
      tags.push(divisionPath!.replaceAll('/', ''))
    }
    if (!development?.id && !property?.id) {
      tags.push('Contacto')
    }

    if (property?.id) {
      tags.push('Propiedad')
    }

    if (development?.id) {
      tags.push(development.name)
    }

    const { name, cellphone, email, text } = datos

    const body = makeJsonContact({
      name,
      cellphone,
      email,
      text,
      tags,
      property,
      development,
    })

    const type = development ? 'development' : property ? 'property' : 'contact'

    if (API_KEY) {
      // sendContactFormTokko({ API_KEY: API_KEY, body: body })
      sendContactFormMediacore({
        data: {
          ...datos,
          tags: tags,
          property: property,
          development: development,
          url: location.href,
        },
        type: type,
        site: global_data.id,
      })
    } else {
      sendContactFormMediacore({
        data: {
          ...datos,
          tags: tags,
          property: property,
          development: development,
          url: location.href,
        },
        type: type,
        site: global_data.id,
      })
    }
    ;(document?.getElementById('formContact') as HTMLFormElement).reset()
    return toast.success('¡Mensaje enviado correctamente!')
  }

  useEffect(() => {
    if (!captcha) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
    setElementFixedTop(screen?.height / 8)
  }, [])

  const getUtm = () => {
    if (typeof window !== 'undefined') {
      var queryString = window.location.search
      var urlParams = new URLSearchParams(queryString)
      const tags = []
      for (const [key, value] of urlParams) {
        if (key.includes('source')) {
          tags.push('Origen: ' + value)
        }
        if (key.includes('medium')) {
          tags.push('Pieza: ' + value)
        }
        if (key.includes('campaign')) {
          tags.push('Campaña: ' + value)
        }
      }
      return tags
    }
    return []
  }

  const [fixedTop, setElementFixedTop] = useState(0)
  const [originalOffset, setElementOriginalOffset] = useState(1080)

  $(document).ready(function () {
    setElementOriginalOffset(
      (screen.height / 100) * parseInt(height?.desktop.replaceAll('vh', '')!),
    )
    $('body').on('scroll', onScrollFunction)
  })

  function onScrollFunction() {
    const scrollTop = $('body').scrollTop() // Obtiene la posición actual del scroll
    const fixedElement: any = document.querySelector('.form-floatante-4')

    const triggerElement: any = document.querySelector('.ubicacion-main')
    const computedStyle = window.getComputedStyle(triggerElement)
    const computedStyleForm = window.getComputedStyle(fixedElement)

    // Obtener el valor de `padding-bottom`
    const paddingBottom = computedStyle.getPropertyValue('padding-bottom')
    const position = computedStyleForm.getPropertyValue('position')
    const paddingBottomValue = parseFloat(paddingBottom) // Convertir "20px" a 20

    // Calcula la posición del triggerElement
    const triggerBottom = triggerElement?.getBoundingClientRect().bottom

    const element = $('#form-detail-float')

    const bottomLocationComponent = triggerBottom + paddingBottomValue

    const elementLocation: any = document.querySelector('.ubicacion-main')
    const componentBottomPosition = elementLocation.getBoundingClientRect().top

    // else {

    if (scrollTop! > componentBottomPosition + scrollTop) {
      setIsAbsolute(true)
      // element.css({
      //   position: 'absolute',
      //   top: `${scrollTop! + 100}px`,
      // })
      element.css({
        position: 'absolute', // Vuelve a su posición original
        top:
          scrollTop! > componentBottomPosition + scrollTop
            ? componentBottomPosition + scrollTop + 85 + 'px'
            : height?.desktop!,
        right: '40px',
      })
      console.log('El scroll ha pasado el inicio del componente.')
    } else {
      if (scrollTop! >= originalOffset - fixedTop) {
        element.css({
          position: 'fixed',
          top: `${75}px`,
          right: '55px',
        })
      } else {
        element.css({
          position: 'absolute', // Vuelve a su posición original
          top: height?.desktop!,
          right: '40px',
        })
      }
    }
    // }
  }
  return (
    <section
      className="form-floatante-4 right"
      id="form-detail-float"
      style={{ top: height?.desktop || '100vh' }}
    >
      {data?.producer?.id && (
        <div className="top-producer">
          <div className="d-flex align-items-center">
            <img
              src={data?.producer?.picture}
              alt={data?.producer?.name}
            />
            <div className="d-flex flex-column">
              <p
                style={{ fontFamily: 'pBoldCustomFont', lineHeight: 1.2 }}
                className="mb-0"
              >
                {data?.producer?.name}
              </p>
              <p>Asesor comercial</p>
            </div>
          </div>
        </div>
      )}
      <form
        onSubmit={sendForm}
        id="formContact"
        className={'row content-form ajax-form '}
      >
        <h2 style={{ color: titleHexa || '#000' }}>{title}</h2>
        <p style={{ color: paragraphHexa || '#000' }}>
          {subtitle} <div className="d-inline-block text-primary">{spanText}</div>
        </p>
        <div className={`col-lg-12 mb-lg-4`}>
          <input
            type="text"
            name="name"
            onChange={handleInputChange}
            placeholder="Nombre y Apellido"
            style={customBorderRadius ? { borderRadius: `${customBorderRadius}px` } : {}}
          />
        </div>
        {!is_short && (
          <div className="col-lg-6 mb-lg-4">
            <input
              type="text"
              name="cellphone"
              onChange={handleInputChange}
              placeholder="Teléfono"
              style={customBorderRadius ? { borderRadius: `${customBorderRadius}px` } : {}}
            />
          </div>
        )}
        <div className="col-lg-6 mb-lg-4 pr-lg-3">
          <input
            type="email"
            name="email"
            onChange={handleInputChange}
            placeholder="Mail*"
            required
            style={customBorderRadius ? { borderRadius: `${customBorderRadius}px` } : {}}
          />
        </div>
        <div className="col-lg-12 mb-lg-4">
          <textarea
            name="text"
            cols={30}
            rows={5}
            onChange={handleInputChange}
            placeholder="Mensaje"
            style={customBorderRadius ? { borderRadius: `${customBorderRadius}px` } : {}}
          ></textarea>
        </div>
        <div className="col-lg-12 d-lg-flex justify-content-between mb-5">
          <p className="d-block d-lg-none">*Campo obligatorio.</p>
          <div className="">
            {captcha ? (
              <ReCAPTCHA
                sitekey={captcha}
                onChange={() => setDisabled(false)}
              />
            ) : (
              ''
            )}

            <button
              type="submit"
              disabled={disabled}
              className={'btn btn-primary border submit mt-4 w-100 '}
              id="submit-info"
              style={customBorderRadius ? { borderRadius: `${customBorderRadius}px` } : {}}
            >
              {button?.value || 'Enviar'}
              {button?.image && (
                <img
                  className="ms-3 pb-1"
                  src={button.image}
                />
              )}
            </button>
          </div>
          <p className="d-none d-lg-block">*Campo obligatorio.</p>
        </div>
      </form>
    </section>
  )
}

export default FormDevelopment_3
